module.exports = __webpack_public_path__ + "img/p3_11.d671db13.webp";